import { sampleLabel } from './sampleLabel';

import './ComparisonLabel.scss';

export const ComparisonLabel = sampleLabel('wdk-ComparisonLabel');
